// export const BaseUrl= "https://rewards.federal.money/api/user";

export const BaseUrl = process.env.REACT_APP_API_URL
// https://nestbuy.lorvensofttech.com/api/v1/
